import {CaretLeftOutlined as AntdCaretLeftOutlined} from '@ant-design/icons';

export default function CaretLeftOutlined(props) {
  return <AntdCaretLeftOutlined {...props} />;
}
